<template>
  <base-button class="btn-danger" text="利用停止" />
</template>
<script>
import BaseButton from "@/views/atoms/BaseButton";

export default {
  name: 'FreezeButton',
  components: {
    BaseButton
  },
}
</script>
